const BASE = "https://buildgreenalbania.org/blogMng.php?";

const getServices  = `${BASE}/getServices`;
const getNews      = `${BASE}/getNews`;
const getComponent = `${BASE}/get`;
const sendMail     = `${BASE}/postEmail`;
const getFileData  = `${BASE}/getFileData`;
const getMapsFileList = `${BASE}/getMapsPath`;
const mapsPath     = "https://buildgreenalbania.org/maps";

const publicJsonCache = {};

export const fetchPublicJson = (url) => {
  if (!publicJsonCache[url]) {
    publicJsonCache[url] = fetch(url, {
      method: 'get',
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    })
      .then((r) => r.json())
      .catch((error) => {
        delete publicJsonCache[url];
        throw error;
      });
  }

  return publicJsonCache[url];
};

export const fetchPublicDataFile = (filename) =>
  fetchPublicJson(`${getFileData}/${filename}`);

export const fetchPublicMapsList = () =>
  fetchPublicJson(getMapsFileList);

// Admin endpoints
const adminLogin   = `${BASE}/adminLogin`;
const pushData     = `${BASE}/pushData`;   // POST /pushData/<filename.json>  (needs X-Admin-Auth header)
const uploadPhoto  = `${BASE}/uploadPhotoAdmin`;

// Admin token helpers
const ADMIN_TOKEN_KEY = 'bgg_admin_token';
export const getAdminToken  = () => localStorage.getItem(ADMIN_TOKEN_KEY) || '';
export const setAdminToken  = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);
export const isAdminLoggedIn = () => !!localStorage.getItem(ADMIN_TOKEN_KEY);

export const adminHeaders = () => ({
  'Content-Type': 'application/json',
  'X-Admin-Auth': getAdminToken(),
});

// Fetch a data file (public)
export const fetchDataFile = (filename) =>
  fetch(`${getFileData}/${filename}`, {
    method: 'get',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then((r) => r.json());

// Save a data file (admin only)
export const saveDataFile = (filename, data) =>
  fetch(`${pushData}/${filename}`, {
    method: 'POST',
    headers: adminHeaders(),
    body: JSON.stringify(data),
  }).then((r) => r.json());

// Upload a photo (admin only)
export const uploadPhotoFile = (file) => {
  const fd = new FormData();
  fd.append('fileToUpload', file);
  return fetch(uploadPhoto, {
    method: 'POST',
    headers: { 'X-Admin-Auth': getAdminToken() },
    body: fd,
  }).then((r) => r.json());
};

// Admin login
export const doAdminLogin = (password) =>
  fetch(adminLogin, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  }).then((r) => r.json());

export default {
  getServices,
  getNews,
  getComponent,
  sendMail,
  getFileData,
  getMapsFileList,
  mapsPath,
  adminLogin,
  pushData,
  uploadPhoto,
};



// WEBPACK FOOTER //
// ./src/APICall/Api.jsx